import React, { useState, useRef } from 'react'
// import { Colors } from '../constants/colors'

export default (props) => {
    const [val, setVal] = useState(props.defaultChecked)
    const inputYes = useRef(null)
    const inputNo = useRef(null)
    const inputValidation = useRef(null)

    // Yes/No checkboxes are mutually exclusive
    const handleYesNoChange = (e) => {
        let v = null
        // if the checkbox's if ends with '|YES'
        if (e.target === inputYes.current && e.target.checked) {
            inputNo.current.checked = false
            v = true
        } else if (e.target === inputNo.current && e.target.checked) {
            inputYes.current.checked = false
            v = false
        };

        setVal(v)
        if (props.onChange)
            props.onChange(returnObject(v))
    }

    const returnObject = (v) => {
        inputValidation.current['checkedValue'] = v
        
        return {
            target: inputValidation.current,
        }
    }
    
    return (
        <div
            style={{ display: 'inline-flex' }}
        >
            <input
                className='validation-dummy'
                style={{ width: '106px' }}
                onKeyPress={(e) => e.preventDefault()}
                ref={inputValidation}
                required={props.required && val === null ? 'required' : ''}
                tabIndex={-1}    
            ></input>
            <div
                className="form-check form-check-inline">
                <input
                    className="form-check-input"
                    name={`${props.name}|YES`}
                    id={`${props.name}|YES`}
                    ref={inputYes}
                    defaultChecked={val === true}
                    onChange={handleYesNoChange}
                    type="checkbox"
                    disabled={props.disabled} />
                <label
                    className="form-check-label"
                    htmlFor={`${props.name}|YES`}>
                    Yes
                </label>
            </div>
            <div
                className="form-check form-check-inline">
                <input
                    className="form-check-input"
                    name={`${props.name}|NO`}
                    id={`${props.name}|NO`}
                    ref={inputNo}
                    defaultChecked={val === false}
                    onChange={handleYesNoChange}
                    type="checkbox"
                    disabled={props.disabled} />
                <label
                    className="form-check-label"
                    htmlFor={`${props.name}|NO`}>
                    No
                </label>
            </div>
        </div>
    )
}